import { apiClient } from "../apiClient";
export const KHOI_NGANH_ENDPOINT = "khoi-nganh";
export const khoiNganhApi = {
  SelectAll: () => apiClient.get(`${KHOI_NGANH_ENDPOINT}`),
};
